import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import ShopFeatureImage from "./shopFeatureImage";
import FeatureName from "../../../visComponents/featureName";
import FeatureDescription from "../../../visComponents/featureDescription";
import FeatureSubDescription from "../../../visComponents/featureSubDescription";
import {featureInterface} from "../../../../interfaces/featureInterface";
import ShopFeatureVisualizeButton from "./shopFeatureVisualizeButton";
import ShopFeaturePrice from "./shopFeaturePrice";
import ShopFeatureShipping from "./shopFeatureShipping";
import ShopFeatureOptions from "./shopFeatureOptions";
import {navFeatureCLick} from "../../lookNavigation/lookFunctions";
import {enableRelatedFeature} from "../../lookNavigation/lookFunctions2";
import {updateCanvasCount} from "../../../../actions/actionFunctions";
// import ShopFeatureQuantity from "./shopFeatureQuantity";
import ShopFeatureAddToCartComponents from "./shopFeatureAddToCartComponents";
import ShopFeatureSuccessMessage from "./shopFeatureSuccessMessage";
import ShopFeatureDownloads from "./shopFeatureDownloads";
import ShopFeatureBackNextButtons from "./shopFeatureBackNextButtons";
import {shopContextAction, useShopContext} from "../shopCategory/shopNavItemsContext";
import ShopFeatureWizardButton from "./shopFeatureWizardButton";
// import ShopFeatureContext from "./shopFeatureContext";
// import {useShopContext} from "../shopCategory/shopNavItemsContext";


const ShopFeature = (props) => {

  const {feature, updateLookCartItem, updateCanvasCount} = props;

  const {shopContextDispatch} = useShopContext();

  useEffect(() => {
    navFeatureCLick(feature);
    enableRelatedFeature(feature);
    updateLookCartItem(feature);
    updateCanvasCount();
    shopContextDispatch(shopContextAction({shopLastActiveFeature: feature}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feature])

  // const {shopContextState} = useShopContext(ShopFeatureContext);
  // const {feature} = shopContextState;

  return (
    <div className="shop">
      <div className="shop-container shop-container--full-height shop-feature">
        <div className="shop-feature__left">
          <ShopFeatureBackNextButtons feature={feature}/>
          <ShopFeatureImage feature={feature}/>
          <div className="shop-feature__left-buttons">
            <ShopFeatureVisualizeButton feature={feature}/>
            <ShopFeatureWizardButton feature={feature}/>
          </div>
        </div>
        <div className="shop-feature__main">
          <h1 className="shop-feature__title">
            <FeatureName feature={feature}/>
          </h1>
          <ShopFeaturePrice feature={feature}/>
          <ShopFeatureShipping feature={feature}/>
          <ShopFeatureOptions feature={feature}/>
          {/*<ShopFeatureMetaOptions/>*/}
          <div className="shop-feature__description">
            <h3 className="shop-feature__sub-title">
              <FormattedMessage id="shop.feature.quantity"/>
            </h3>
            <ShopFeatureAddToCartComponents feature={feature}/>
            <ShopFeatureSuccessMessage/>
          </div>
          <div className="shop-feature__description">
            <h3 className="shop-feature__sub-title">
              <FormattedMessage id="shop.feature.description"/>
            </h3>
            <div className="shop-feature__description-text">
              <FeatureDescription feature={feature}/>
            </div>
          </div>
          <div className="shop-feature__description">
            <h3 className="shop-feature__sub-title">
              <FormattedMessage id="shop.feature.overview"/>
            </h3>
            <div className="shop-feature__description-text">
              <FeatureSubDescription feature={feature}/>
            </div>
          </div>
          <ShopFeatureDownloads feature={feature}/>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  updateCanvasCount
};

ShopFeature.propTypes = {
  feature: PropTypes.shape(featureInterface)
}

export default connect(mapStateToProps, mapDispatchToProps)(ShopFeature)
